import initMK from '../_core/init.js';
import defineProp from '../_core/defineprop.js';
import matreshkaError from '../_helpers/matreshkaerror.js';
import forEach from '../_helpers/foreach.js';
import triggerOne from '../trigger/_triggerone.js';
// adds keys to a list of data keys
export default function addDataKeys(givenKeys) {
  var _this = this;
  for (var _len = arguments.length, _rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    _rest[_key - 1] = arguments[_key];
  }
  var _initMK = initMK(this),
    keys = _initMK.keys;
  var newKeys;
  // accept an array keys or a list of args
  if (Array.isArray(givenKeys)) {
    newKeys = givenKeys;
  } else {
    newKeys = arguments;
  }
  forEach(newKeys, function (key) {
    if (typeof key !== 'string') {
      throw matreshkaError('adddatakeys:key_type', {
        key: key
      });
    }
    // if key is not in a list of keys
    if (!(key in keys)) {
      // define descriptors for this property
      var _defineProp = defineProp(_this, key),
        value = _defineProp.value;
      var eventOptions = {
        key: key,
        value: value
      };
      // add a key to the list of keys
      keys[key] = true;
      // delegate asterisk listeners to the current value
      triggerOne(_this, '_asterisk:set', eventOptions);
      // trigger events which say that data is changed
      triggerOne(_this, 'set', eventOptions);
      triggerOne(_this, 'modify', eventOptions);
    }
  });
  return this;
}